<template>
	<select :id='id' @change="change" v-model="selected" class='form-control table-control my-control' data-num='f_20' data-table='1'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const LOCALFORESTRY = 'localforestrie_list.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'localforestry',
		data: function () {
			return {
				selected: '0',
				options: [],
				id: `${this.type}_localforestry_${this.line_count}`,
			}
		},
		methods: {
			fill (id) {
				//console.log(id)
				fetch(DB + LOCALFORESTRY + '?id=' + id)
				.then(data => data.json())
				.then(data => {
					if (data) {
						if(this.$props.lf_id) {
							this.selected = this.$props.lf_id
							this.change()
						}
							
						this.options = [{id: '0', name: ''}, ...data];
					}
					else {
						this.options = []
						this.selected = '0'
					}
				})
				.catch(err => console.log(err))
			},
			change () {
				EventBus.$emit(`${this.type}_localforestry_${this.line_count}`, this.selected)
				EventBus.$emit(`${this.type}_localforestry`, {index: this.line_count, value: this.selected})
			}
		},
		props: {
			line_count: 0,
			lf_id: null,
			forestry_id: null,
			type: ''
		},
		created: function () {
			EventBus.$on(`${this.type}_forestry`, id => {
				this.fill(id)
			})

			this.fill(this.forestry_id)
		},
		beforeDestroy () {
			EventBus.$off(`${this.type}_forestry`)
		}

	}
</script>


// WEBPACK FOOTER //
// localforestry.vue?9302d314